export default class NoRouteError extends Error {
  constructor(e = "Il n'y a aucun itinéraire pour ce mode de transport") {
    super(e)
    this.name = 'NoRouteError'
  }
}
